const $slider = document.querySelectorAll('.testimonials-slider__carousel');

const fn = {
    init: () => {
        let testimonialCarouselMargin = 80;
        if ($($slider).data('carousel-margin') !== undefined) {
            testimonialCarouselMargin = $($slider).data('carousel-margin');
        } else {
            testimonialCarouselMargin = 80;
        }
        let testimonialCarousel = $($slider).owlCarousel({
            loop: true,
            margin: testimonialCarouselMargin,
            nav: false,
            dots: true,
            autoWidth: false,
            autoplay: true,
            smartSpeed: 700,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1,
                },
                480: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1000: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        });

        $('.testimonials-slider__navbtn-left').on('click', () => {
            testimonialCarousel.trigger('next.owl.carousel');
            return false;
        });
        $('.testimonials-slider__navbtn-right').on('click', () => {
            testimonialCarousel.trigger('prev.owl.carousel');
            return false;
        });
    },
};

export default {
    can: () => $slider.length,
    run: fn.init,
};
